import * as React from "react";
import { Button, Classes, Dialog, Radio } from "../externals";
import { colorSchemes } from "./colorSchemes";
import { PaletteCanvas } from "./PaletteCanvas";
export class PalettePicker extends React.PureComponent {
    constructor(props) {
        super(props);
        this.updatePalette = (palette) => {
            this.props.onChange(palette);
        };
        this.isDialogOpen = (status) => {
            this.setState({ dialogOpenStatus: status });
        };
        this.paletteRenamer = (paletteName) => {
            const isUpperCase = (char) => char.toUpperCase() === char ? true : false;
            let renamedPalette = "";
            for (let i = 0; i < paletteName.length; i++) {
                if (isUpperCase(paletteName.charAt(i))) {
                    if (i !== 0) {
                        renamedPalette += "-" + paletteName.charAt(i);
                    }
                    else {
                        renamedPalette += paletteName.charAt(i);
                    }
                }
                else {
                    renamedPalette += paletteName.charAt(i);
                }
            }
            return renamedPalette;
        };
        this.state = {
            dialogOpenStatus: false,
        };
    }
    render() {
        const schemeOptions = () => {
            let options = [];
            Object.keys(colorSchemes).forEach((canv) => {
                options.push(React.createElement("div", { key: canv, style: { display: "flex", alignItems: "center" } },
                    React.createElement(PaletteCanvas, { height: 40, width: 400, color: colorSchemes[canv], useBorder: true, margin: 15 }),
                    React.createElement(Radio, { checked: colorSchemes[this.props.defaultPalette] === colorSchemes[canv], label: this.paletteRenamer(canv), value: canv, onChange: (e) => {
                            this.updatePalette(e.currentTarget.value);
                        } })));
            });
            return options;
        };
        return (React.createElement("div", { style: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
            } },
            React.createElement("div", { style: { display: "flex", border: "1px solid #000000" } },
                React.createElement(Button, { icon: "edit", onClick: () => this.isDialogOpen(true), text: "Change color palette", minimal: true }),
                React.createElement(PaletteCanvas, { height: this.props.height, width: this.props.width, color: colorSchemes[this.props.defaultPalette] })),
            React.createElement(Dialog, { onClose: () => this.isDialogOpen(false), isOpen: this.state.dialogOpenStatus, title: "Color palettes", isCloseButtonShown: true, icon: "edit", style: { height: "475px", width: "650px" } },
                React.createElement("div", { className: Classes.DIALOG_BODY, style: { overflow: "auto" } }, schemeOptions()))));
    }
}
//# sourceMappingURL=PalettePicker.js.map